import React, { Component, Fragment } from "react";
import { PureComponent } from "react";
import {
  CompositionContext,
  FixturesContext,
  ConstraintsContext,
} from "../../Context";
import { Consume } from "../../Context/Consumer";
import { getTeamDeadlineObj } from "./helper";

class Fixtures extends PureComponent {
  constructor(props) {
    super(props);
    // this.autoComplete.bind(this)
  }

  getTeamName = (list, id) => {
    let nameObj = list.find((el) => {
      return el.TeamId == id;
    });
    return nameObj;
  };

  render() {
    let {
      trans,
      config,
      getTrans,
      currMatchDay,
      playerDetailsObj,
      isLiveMatch,
      CompositionData,
      mode,
      ConstraintsData,
    } = this.props;

    const isFixtureUpdated =
      playerDetailsObj.isFixtureUpdated === 1 ||
      playerDetailsObj.isFixtureUpdated === "1";

    let matchDayData = currMatchDay;
    let matchStatus = matchDayData.MatchStatus;
    let MMinutes = matchDayData.liveMinutes + "'";
    let isPlayerLive = matchDayData.isPlayerLive;
    let Phase = matchDayData.PhaseId;
    let liveStatus = matchDayData.IsLive ? matchDayData.IsLive : "";
    let HTID = matchDayData.HomeTeamCountryCode;
    let htName = this.getTeamName(
      CompositionData.TeamListContextData,
      matchDayData.HomeTeamId
    )?.WebName; /* matchDayData.HomeTeamName */
    let htImg = `${config.IMG_BASE}clubs/${matchDayData.HomeTeamId}.png?v=${ConstraintsData?.data?.PlayerJerseyTeamVersion}`;

    let htScr = matchDayData.HomeTeamScore ? matchDayData.HomeTeamScore : 0;
    let ATID = matchDayData.AwayTeamCountryCode;
    let atName = this.getTeamName(
      CompositionData.TeamListContextData,
      matchDayData.AwayTeamId
    )?.WebName; /* matchDayData.AwayTeamName; */
    let atImg = `${config.IMG_BASE}clubs/${matchDayData.AwayTeamId}.png?v=${ConstraintsData?.data?.PlayerJerseyTeamVersion}`;
    let atScr = matchDayData.AwayTeamScore ? matchDayData.AwayTeamScore : 0;
    let fixtureHeader = "";
    let statusClass = "";
    let fixtureHeaderClass = "si-stats-details si-fixture-details";
    if (matchStatus === "0") {
      //upcoming  si-upcoming
      let matchTime = "";
      let matchDate = matchDayData.MatchDateTime;
      let displayDate = "";
      if (matchDate) {
        displayDate = getTeamDeadlineObj(
          trans,
          config.WebConfig.OffSet,
          matchDate
        ).displayDate;
        matchTime = getTeamDeadlineObj(
          trans,
          config.WebConfig.OffSet,
          matchDate
        ).matchTime;
      }
      statusClass = "si-upcoming";
      fixtureHeader = (
        // <div className="si-fix__mid si-fix--vs">
        //   <span className="si-match-date">{displayDate}</span>
        //   <span className="si-match-time">{matchTime}</span>
        // </div>
        <div className="si-fixtures__status">
          <span>{getTrans(trans, "vs", "vs")}</span>
        </div>
      );
    } else if (matchStatus === "1") {
      //live

      if (liveStatus == config.liveScoringStates.live) {
        statusClass = "si-live";
      } else {
        statusClass = "si-live";
      }
      let middleMrkUp =
        liveStatus == 1
          ? ""
          : Phase && Phase.toLowerCase() == "ht"
          ? Phase
          : MMinutes
          ? MMinutes
          : "-";

      fixtureHeader = (
        // <div className="si-fix__mid si-fix--vs">
        //   <span>{htScr + " - " + atScr}</span>
        //   <div className="si-match--penalty">{middleMrkUp}</div>
        // </div>

        <div className="si-fixtures__status">
          <span>{getTrans(trans, "live", "Live")}</span>
        </div>
      );
    } else if (matchStatus === "2") {
      statusClass = "si-completed";
      fixtureHeader = (
        <div className="si-fixtures__status">
          <span>{getTrans(trans, "ft", "FT")}</span>
        </div>
      );
    }
    // <!-- si-live | si-completed | si-upcoming -->
    /* let screenMode = this.props.screenMode;
    let isMatchLiveIncreateTeam = !isLiveMatch && matchStatus == "1";
    if (isMatchLiveIncreateTeam) {
      statusClass = "si-live";
      let middleMrkUp = ;

      fixtureHeader = (
        <div className="si-fix__mid si-fix--vs">
          <span>{middleMrkUp}</span>
        </div>
      );
    }
 */
    return (
      <Fragment>
        <div className={`si-fixtures__match ${statusClass}`}>
          <div className="si-fixtures__team si-lhs">
            <div
              className="si-fixtures__team-logo"
              style={{ backgroundImage: "url(" + htImg + ")" }}
            />
            <div className="si-fixtures__team-name">
              <span>{htName}</span>
            </div>
          </div>
          {fixtureHeader}
          <div className="si-fixtures__team">
            <div
              className="si-fixtures__team-logo"
              style={{ backgroundImage: "url(" + atImg + ")" }}
            ></div>
            <div className="si-fixtures__team-name">
              <span>{atName}</span>
            </div>
          </div>
        </div>

        {/* <div className={"si-fix__box " + statusClass}>
          <div className="si-fix__left si-fix--a">
            <div className="si-fix__player">{htName}</div>
            <div
              className="si-fix__img"
              style={{ backgroundImage: "url(" + htImg + ")" }}
            ></div>
          </div>
          {fixtureHeader}
          <div className="si-fix__right si-fix--b">
            <div
              className="si-fix__img"
              style={{ backgroundImage: "url(" + atImg + ")" }}
            ></div>
            <div className="si-fix__player">{atName}</div>
          </div>
        </div> */}
      </Fragment>
    );
  }
}

export default Consume(Fixtures, [
  CompositionContext,
  FixturesContext,
  ConstraintsContext,
]);
